import type { TourDef } from '../types';

/** For HR: the recognition programme's tabs in the Admin Center (the tab bar is the stable part of these pages). */
const hr: TourDef = {
  id: 'hr',
  version: 1,
  route: '/admin/recognition/rules',
  roles: ['hr'],
  steps: [
    { target: '[data-tour="admin-tab-rules"]', key: 'rules' },
    { target: '[data-tour="admin-tab-eligibility"]', key: 'eligibility' },
    { target: '[data-tour="admin-tab-champions"]', key: 'champions' },
    { target: '[data-tour="admin-tab-points"]', key: 'points' },
  ],
};

export default hr;
